import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState(false);
	const [emailSent, setEmailSent] = useState(false);
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			await axios.post(`${API}/auth/forgot-password`, { email });
			setEmailSent(true);
			toast.success('Password reset link sent to your email!');
		} catch (err) {
			let errorMessage = 'Failed to send reset link';
			if (err.response?.data?.detail) {
				const detail = err.response.data.detail;
				if (Array.isArray(detail)) {
					errorMessage = detail.map(e => e.msg || e.message).join(', ');
				} else if (typeof detail === 'string') {
					errorMessage = detail;
				}
			}
			toast.error(errorMessage);
		}
		setLoading(false);
	};

	return (
		<div className="auth-page-wrapper">
			<div className="auth-container-new">
				<div className="auth-card-new">
					{/* Illustrated hero — same as the login card */}
					<div className="auth-hero">
						<span className="auth-hero__star auth-hero__star--1" />
						<span className="auth-hero__star auth-hero__star--2" />
						<span className="auth-hero__star auth-hero__star--3" />
						<span className="auth-hero__star auth-hero__star--4" />
						<span className="auth-hero__star auth-hero__star--5" />
						<div className="auth-hero__brand">
							<img className="auth-hero__logo" src="/images/orbit-logo.svg" alt="Orbit" />
							<span className="auth-hero__name">Orbit Analytics</span>
						</div>
						<span className="auth-hero__cloud auth-hero__cloud--left" />
						<span className="auth-hero__cloud auth-hero__cloud--right" />
						<span className="auth-hero__cloud auth-hero__cloud--center" />
					</div>

					{!emailSent ? (
						<>
							<div className="auth-header-new">
								<h2>Forgot Password?</h2>
								<p>Enter your email and we'll send you a reset link</p>
							</div>

							<form onSubmit={handleSubmit} className="auth-form-new">
								<div className="form-group">
									<label>Email Address</label>
									<Input
										type="email"
										placeholder="you@example.com"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										required
										className="auth-input"
									/>
								</div>
								<Button type="submit" disabled={loading} className="auth-submit-btn">
									{loading ? 'Sending...' : 'Send Reset Link'}
								</Button>
							</form>

							<div className="auth-footer">
								<p>
									Remember your password?{' '}
									<button onClick={() => navigate('/auth')} className="auth-switch-link">
										Sign In
									</button>
								</p>
							</div>
						</>
					) : (
						<div className="email-sent-message">
							<div className="email-icon">
								<Mail className="w-16 h-16 text-indigo-600" />
							</div>
							<h2>Check Your Email</h2>
							<p>We've sent a password reset link to <strong>{email}</strong></p>
							<p className="text-sm text-gray-500 mt-4">
								Didn't receive the email? Check your spam folder or{' '}
								<button
									onClick={() => setEmailSent(false)}
									className="text-indigo-600 hover:underline"
								>
									try again
								</button>
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ForgotPasswordPage;
